import { App as AntdApp, Button } from 'antd';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import canvasWebSocket, { type ReportCompletionListener } from '@/services/websocket-service';

const PLANNING_ROUTE = '/home/planning';

export default function ReportCompletionNotifier() {
  const { notification } = AntdApp.useApp();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const listener: ReportCompletionListener = ({ threadId }) => {
      if (location.pathname.startsWith(PLANNING_ROUTE)) {
        return;
      }

      const notificationKey = `report-ready-${threadId ?? 'current'}`;
      notification.success({
        key: notificationKey,
        message: 'Your report is ready',
        description:
          'Your report has finished generating. Continue to Wavvest Planning to review it.',
        duration: 0,
        actions: (
          <Button
            type="primary"
            size="small"
            onClick={() => {
              notification.destroy(notificationKey);
              navigate('/home/planning/guided-mode-v2');
            }}
          >
            View report
          </Button>
        ),
      });
    };

    canvasWebSocket.addReportCompletionListener(listener);
    return () => {
      canvasWebSocket.removeReportCompletionListener(listener);
    };
  }, [location.pathname, navigate, notification]);

  return null;
}
